import { CostReviewBidDocumentationAvailable } from "./CostReviewBidDocumentationAvailable";
import { CostReviewContractualDocumentation } from "./CostReviewContractualDocumentation";
import { CostReviewElectricalWiring } from "./CostReviewElectricalWiring";
import { CostReviewerDetails } from "./CostReviewerDetails";
import { CostReviewGeneralConditions } from "./CostReviewGeneralConditions";
import { CostReviewMarginExceptions } from "./CostReviewMarginExceptions";
import { CostReviewOperatorWorkstationSoftware } from "./CostReviewOperatorWorkstationSoftware";
import { CostReviewPlannedCosts } from "./CostReviewPlannedCosts";
import { CostReviewProjectMgmtRequirements } from "./CostReviewProjectMgmtRequirements";
import { CostReviewSummary } from "./CostReviewSummary";

export class CostReviewBaseAttributes {
  costReviewSummary: CostReviewSummary = new CostReviewSummary();
  isAutoUnlockBySystem!: boolean;
  isOptionalCheckboxStatusSavedLessOneFiftyK!: boolean;
  isOptionalCheckboxStatusSavedGreaterOneFiftyK!: boolean;
  isConfiguredforOptionalWorkflow!: boolean;
  isCpmVisible!: boolean;
  reviewerDetailsForRequestPreference!: Array<CostReviewerDetails>;
  isMinimumColumnVisible!: boolean;
  costReviewPlannedCosts: CostReviewPlannedCosts[] = [];
  costReviewMarginExceptions: CostReviewMarginExceptions = new CostReviewMarginExceptions();
  costReviewGeneralConditions: CostReviewGeneralConditions = new CostReviewGeneralConditions();
  costReviewBidDocumentationAvailable: CostReviewBidDocumentationAvailable = new CostReviewBidDocumentationAvailable();
  costReviewContractualDocumentation: CostReviewContractualDocumentation = new CostReviewContractualDocumentation();
  costReviewProjectMgmtRequirements: CostReviewProjectMgmtRequirements = new CostReviewProjectMgmtRequirements();
  costReviewOperatorWorkstationSoftware: CostReviewOperatorWorkstationSoftware = new CostReviewOperatorWorkstationSoftware();
  costReviewElectricalWiring: CostReviewElectricalWiring = new CostReviewElectricalWiring();
  costTotal: number = 0;
  tdcTotal: number = 0;
  itemCostTotal: number = 0;
  itemTDCTotal: number = 0;
  isEngineerExceptionApplicable: boolean = false;
  engineerApprovalReceived: number = 0;
  engineerApproverEmail: string = '';
  engineerReasonForException: string = '';
  isNationalHistoricalRowVisible: boolean = false;
}
